import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  constructor(private _elementRef: ElementRef) { }

  @Output()
  public clickOutside = new EventEmitter<void>();

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: EventTarget | null) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement as Node | null);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
